module.exports = __webpack_public_path__ + "static/media/ServerIcon.d4a9692e.svg";